const yup = require('yup');

const name = yup.string().min(2, 'MIN_LENGTH').max(110, 'MAX_LENGTH');

const potName = yup.string().min(5, 'POT_MIN_LENGTH').max(60, 'MAX_LENGTH');

const organizer = yup.string().min(2, 'MIN_LENGTH').max(60, 'MAX_LENGTH');

const url = yup
    .string()
    .matches(
        /^((?!\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]).)*$/,
        'EMOTES_NOT_SUPPORTED',
    )
    .matches(/^[-_a-zA-Z0-9]{0,100}$/, 'SPECIAL_CHARACTERS_NOT_SUPPORTED ')
    .min(2, 'MIN_LENGTH')
    .max(100, 'MAX_LENGTH');

const nonNumericalRegex = new RegExp('^([^0-9]*)$');
const userName = yup
    .string()
    .matches(/^[A-Za-zàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšž '-]+$/, 'CARACTERS_NOT_SUPPORTED')
    .min(2, 'MIN_LENGTH')
    .max(60, 'MAX_LENGTH')
    .matches(nonNumericalRegex, 'NON_NUMERICAL');

const iban = yup
    .string()
    .matches(
        /^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/,
        'IBAN_FORMAT_INVALID',
    );
const bic = yup.string().matches(/^[a-zA-Z]{6}\w{2}(\w{3})?$/, 'INVALID_FORMAT');

const phoneRegex1 = new RegExp('^0[1-9]([ ]?[0-9]{2}){4}$');
const phoneRegex2 = new RegExp('^\\+[1-9]{1}[0-9]{3,14}$');

const phone = yup
    .string()
    .trim()
    .min(5, 'MIN_LENGTH')
    .max(16, 'MAX_LENGTH')
    .test('phone-regex', 'INVALID', (val) => !val || phoneRegex1.test(val) || phoneRegex2.test(val));

const contributionType = yup.mixed().oneOf(['REGULAR', 'FIXED', 'SUGGESTED'], 'UNKNOWN_VALUE');

const designatedBeneficiary = yup.string().min(2, 'MIN_LENGTH').max(60, 'MAX_LENGTH');

const contributionAmountSuggested = yup.number().typeError('MUST_BE_NUMBER').min(1, 'MIN').max(3000, 'MAX');

const amountToReach = yup.number().typeError('MUST_BE_NUMBER').min(1, 'MIN').max(9999999, 'MAX');

const contributionAmountFixed = yup.number().typeError('MUST_BE_NUMBER').min(1, 'MIN').max(3000, 'MAX');

const email = yup.string().min(5, 'MIN_LENGTH').max(130, 'MAX_LENGTH').email('INVALID');

const emailMessage = yup.string().min(2, 'MIN_LENGTH').max(1500, 'MAX_LENGTH');

const description = yup.string().min(15, 'MIN_LENGTH').max(1500, 'MAX_LENGTH');

const message = yup.string().min(2, 'MIN_LENGTH').max(1500, 'MAX_LENGTH');

const city = yup.string().min(2, 'MIN_LENGTH');

const messageReport = yup.string().min(50, 'MIN_LENGTH').max(1500, 'MAX_LENGTH');

const zipCode = yup.number().typeError('MUST_BE_NUMBER').min(1000, 'INVALID').max(99999, 'INVALID');

const address = yup.string().min(2, 'MIN_LENGTH').max(60, 'MAX_LENGTH');

const collectedAmount = yup.number().typeError('MUST_BE_NUMBER').min(1, 'MIN');

const giftCardAmount = yup.number().typeError('MUST_BE_NUMBER').min(20, 'MIN');

export const potCreateSchema = (requiredFields) =>
    yup.object({
        name: requiredFields && potName.required('REQUIRED'),
        organizer: requiredFields && organizer.required('REQUIRED'),
    });

export const potCreateForLpsSchema = (nameRequired, designatedBeneficiaryRequired) =>
    yup.object({
        name: nameRequired && potName.required('REQUIRED_CUSTOM'),
        designatedBeneficiary: designatedBeneficiaryRequired && designatedBeneficiary.required('REQUIRED_CUSTOM'),
        amountToReach: amountToReach,
    });

export const potCreateSchemaWithContribution = yup.object({
    name: name.required('REQUIRED'),
    organizer: organizer.required('REQUIRED'),
    contributionAmount: contributionAmountSuggested.required('REQUIRED'),
});

export const potSettingsGeneral = yup.object({
    customUrlSuffixPO: url,
});

export const potCollectAmount = yup.object({
    amount: collectedAmount.required('REQUIRED'),
});

export const potSettingsParticipationsRegular = yup.object({
    contributionType: contributionType.required('REQUIRED'),
});

export const potSettingsParticipationsSuggested = yup.object({
    contributionType: contributionType.required('REQUIRED'),
    contributionAmountSuggested: contributionAmountSuggested.required('REQUIRED'),
});

export const potSettingsParticipationsFixed = yup.object({
    contributionType: contributionType.required('REQUIRED'),
    contributionAmountFixed: contributionAmountFixed.required('REQUIRED'),
});

export const giftCardSchema = yup.object({
    amount: giftCardAmount.required('REQUIRED'),
});

export const contactOrganiserSchema = yup.object({
    email: email.required('REQUIRED'),
    message: emailMessage.required('REQUIRED'),
});

export const thankParticipantsSchema = yup.object({
    message: emailMessage.required('REQUIRED'),
});
export const generateDescriptionSchema = yup.object({
    descriptionPrompt: description.required('REQUIRED'),
});

export const addMessageSchema = yup.object({
    message: message.required('REQUIRED'),
});

export const addMessagePotSchema = yup.object({
    message: message.required('REQUIRED'),
});

export const addIbanSchema = yup.object({
    bic: bic.required('REQUIRED'),
    iban: iban.required('REQUIRED'),
});

export const orderGiftCardStep1Schema = yup.object({
    firstName: userName.required('REQUIRED'),
    lastName: userName.required('REQUIRED'),
    street1: address.required('REQUIRED').max(38, 'MAX_LENGTH'),
    telephone: phone.required('REQUIRED'),
    zipCode: zipCode.required('REQUIRED'),
    city: city.required('REQUIRED'),
});

export const orderGiftCardStep2Schema = yup.object({
    email: email.required('REQUIRED'),
});

export const reportPotSchema = yup.object({
    email: email.required('REQUIRED'),
    messageReport: messageReport,
});

export const potUpdateNameSchema = yup.object().shape({
    content: name.required('REQUIRED'),
});
